module.exports = __webpack_public_path__ + "static/media/atulaya.10c0667d.webp";